export default {
    url: '/edit/:id',
    template: '<forms-settings-formcategories-edit form-category="vm.formCategory"></forms-settings-formcategories-edit>',
    resolve: {
        formCategory: (FormCategoryResource, $stateParams) => FormCategoryResource.get({ id: $stateParams.id, expand: 'activeI18n,categoryI18ns' }).$promise
    },
    controller (formCategory) {
        this.formCategory = formCategory;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/formcategories/edit/index.js